"use client"
import { createSvgIcon, useTheme } from "@mui/material"
import type { IconProps } from "../types"
import { getPath } from "../utils"

const Check = createSvgIcon(
  <path d="M4.58327 13.0484L8.48866 16.9538C9.07445 17.5396 10.0242 17.5396 10.61 16.9538L19.4154 8.14836C19.8077 7.75608 19.8077 7.12008 19.4154 6.7278C19.0231 6.33552 18.3871 6.33552 17.9948 6.7278L9.90288 14.8197C9.70761 15.015 9.39103 15.015 9.19577 14.8197L6.00383 11.6278C5.61155 11.2355 4.97555 11.2355 4.58327 11.6278C4.19099 12.0201 4.19099 12.6561 4.58327 13.0484Z" />,
  "Check",
)

const CheckIcon = (props: IconProps) => {
  const { fill, sx, ...rest } = props
  const theme = useTheme()
  const _fill =
    (fill && getPath(theme.palette, fill)) || theme.palette.text.primary
  return <Check sx={{ fill: _fill, ...sx }} {...rest} />
}

export default CheckIcon
